import React from 'react';
import PropTypes from 'prop-types';
import { Column, Li, Ul } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { OrderPaymentMethod } from './OrderPaymentMethod';
import { OrderDetailsCardHeading } from './OrderDetailsCardHeading';

export const PaymentDetails = ({ paymentDetails, columnStyle }) => {
  const [paymentMessages] = useTranslations(['paymentMessages']);
  const { span, px, py } = columnStyle;

  return (
    <Column span={span} px={px} py={py}>
      <OrderDetailsCardHeading testId="payment-details-title">
        {paymentMessages.paymentDetailsTitle}
      </OrderDetailsCardHeading>

      <Ul skin="minimal">
        {paymentDetails.map((pd, index) => (
          <Li key={`payment-method-${index}`}>
            <OrderPaymentMethod paymentDetail={pd} />
          </Li>
        ))}
      </Ul>
    </Column>
  );
};

PaymentDetails.propTypes = {
  paymentDetails: PropTypes.array,
  columnStyle: PropTypes.object,
};
